import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal, Overline } from "./primitives";
import { HIDDEN_COSTS, IMAGES } from "./content";

const EASE = [0.16, 1, 0.3, 1];

function Panel({ item, image, index }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  const flip = index % 2 === 1;

  return (
    <div
      ref={ref}
      className={`grid grid-cols-1 items-center gap-10 md:grid-cols-2 md:gap-20 ${
        flip ? "md:[direction:rtl]" : ""
      }`}
    >
      <div className="clip-frame relative aspect-[4/5] overflow-hidden md:[direction:ltr]">
        <motion.img
          style={{ y }}
          src={image}
          alt={item.title}
          loading="lazy"
          className="absolute inset-0 h-[124%] w-full object-cover"
        />
      </div>

      <div className="md:[direction:ltr]">
        <Reveal>
          <span className="font-serif text-6xl text-champagne md:text-7xl">{item.no}</span>
          <h3 className="mt-4 font-serif text-3xl leading-tight text-ink sm:text-4xl lg:text-5xl">
            {item.title}
          </h3>
          <p className="mt-6 max-w-[42ch] text-base leading-relaxed text-ink/60 md:text-lg">
            {item.body}
          </p>
        </Reveal>
      </div>
    </div>
  );
}

export default function HiddenCosts() {
  return (
    <section data-testid="hidden-costs-section" className="relative bg-stone py-28 md:py-40">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: EASE }}
          className="mb-20 md:mb-32 max-w-[20ch]"
        >
          <Overline className="text-copper">The Hidden Costs</Overline>
          <h2 className="mt-6 font-serif text-4xl leading-[1.05] text-ink sm:text-6xl lg:text-7xl">
            What quietly erodes a great home.
          </h2>
        </motion.div>

        <div className="space-y-24 md:space-y-40">
          {HIDDEN_COSTS.map((item, i) => (
            <Panel key={item.no} item={item} image={IMAGES.hiddenCosts[i]} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
